import moment from "moment";

/**
 * O formato em que a lista de tratamentos isolados guarda as datas.
 *
 * ─── PORQUE É UM CONTRATO, E NÃO UMA ESCOLHA DE APRESENTAÇÃO ────────────────
 *
 * A lista guarda as datas já formatadas, e o modal de execução volta a lê-las
 * de lá para encher os seletores. Quem escreve e quem lê tem de usar a mesma
 * cadeia — e `data_inicio_execucao` não é só o que se mostra: é a marcação na
 * agenda, que a execução reescreve.
 *
 * Estava escrito à mão em quatro sítios e um divergiu: o cancelamento da
 * execução guardava `DD/MM/YYYY`, sem horas. O moment, em modo tolerante,
 * aceita essa cadeia contra `DD-MM-YYYY HH:mm` — acerta no dia e põe 00:00 sem
 * se queixar. O tratamento era executado de novo à meia-noite, com início
 * igual ao fim, e desaparecia da agenda, cuja grelha começa às 8h.
 *
 * Por isso o formato vive aqui, e ninguém o escreve outra vez.
 */
export const FORMATO_LISTA = "DD-MM-YYYY HH:mm";

/** Data do servidor (ISO ou `Date`) → a cadeia que a lista guarda. */
export const formatarParaLista = (valor) =>
  valor ? moment(valor).format(FORMATO_LISTA) : valor;

/**
 * A cadeia da lista → `moment`, para os seletores do modal.
 *
 * Primeiro em modo ESTRITO: se a cadeia não trouxer as horas, a leitura falha
 * em vez de inventar a meia-noite. Depois, como recurso, uma leitura normal —
 * porque há caminhos em que o valor chega cru do servidor, em ISO, sem passar
 * pela lista.
 *
 * Nunca devolve um `moment` inválido em silêncio: se as duas leituras
 * falharem, o inválido chega ao seletor, que o mostra como tal. Uma hora
 * visivelmente errada é melhor do que uma marcação movida para a meia-noite.
 */
export const lerDataDaLista = (valor) => {
  if (!valor) return null;

  const estrito = moment(valor, FORMATO_LISTA, true);
  if (estrito.isValid()) return estrito;

  return moment(valor);
};
